import {useState} from "react";
import {Routes, Route, useParams, Link} from "react-router-dom";
import Entity from "./Entity";
import Activity from "./Activity";
import CardMenu from "../../components/card-menu";
import Menu from "./TopMenu";
import {Card} from "react-bootstrap";
import Icon from "../../components/icon";
import Consents from "./Consents";

const EntityManager = ({audience}) => {
    const {id2} = useParams()
    const AudienceMenu = Menu({audience: audience})
    const paths = window.location.pathname.split("/")
    const [activeMenu, setActiveMenu] = useState(paths[paths?.length - 1])


    const checkActive = (name) => {
        return activeMenu === name ? "active" : ""
    }

    return (
        <Card>
            <CardMenu {...AudienceMenu} />
            <div className="audience-entity">
                <div className="audience-entity-menu">
                    <li>
                        <Link to={`/audiences/${audience?._id?.$oid}/entities`}>
                            <Icon name="back"/> Back to list
                        </Link>
                    </li>
                    <li>
                        <Link
                            onClick={ev => setActiveMenu(id2)}
                            className={checkActive(id2)}
                            to={`/audiences/${audience?._id?.$oid}/entities/${id2}`}>
                            <Icon name="user"/> Edit entity
                        </Link>
                    </li>
                    {audience?.Account?.Plan?.features?.use_consents === 'on' && <li>
                        <Link
                            className={checkActive("consents")}
                            onClick={ev => setActiveMenu("consents")}
                            to={`/audiences/${audience?._id?.$oid}/entities/${id2}/consents`}>
                            <Icon name="check2"/> Consents
                        </Link>
                    </li>}
                </div>
                <div className="audience-entity-form">
                    <Routes>
                        <Route index element={<Entity audience={audience} id_entity={id2}/>}/>
                        <Route path="consents" element={<Consents audience={audience} id_entity={id2}/>}/>
                    </Routes>
                </div>
            </div>
        </Card>
    )
}

export default EntityManager
